import React from 'react';
import PropTypes from 'prop-types';
import CustomRadio from '../common/CustomRadio';
//import CustomInput from './common/CustomInput';
import NewCustomInput from '../common/NewCustomInput';

const Div6 = ({ formData, setFormData, errors, setErrors, handleChange }) => {
  return (
    <div className="mb-6 border-b border-gray-300 pb-4">
      <h3 className="text-lg text-gray-900 font-semibold mb-2">
        Contact Details <span className="text-red-700">*</span>
      </h3>
      <div className="flex">
        <span className="text-gray-900 font-bold mr-5">Background:</span>
        <CustomRadio
          name="contactbg"
          options={['Normal', 'Dark']}
          value={formData.contactbg}
          onChange={handleChange}
          error={errors.contactbg}
          required
        />
      </div>

      <NewCustomInput
        label={<span>WhatsApp</span>}
        id="whatsapp"
        name="whatsapp"
        type="tel"
        value={formData.whatsapp || ''}
        onChange={handleChange}
        placeholder="Enter WhatsApp number"
        error={errors.whatsapp || errors.contact}
        className={`w-full border border-gray-300 rounded-md py-2 px-3 mb-2 ${formData.contactbg === 'Dark' ? 'bg-gray-900 text-white' : 'bg-gray-100 text-gray-600'}`}
      />

      <NewCustomInput
        label={<span>Contact No.</span>}
        id="mobile"
        name="mobile"
        type="tel"
        value={formData.mobile || ''}
        onChange={handleChange}
        placeholder="Enter contact number"
        error={errors.mobile || errors.contact}
        className={`w-full border border-gray-300 rounded-md py-2 px-3 mb-2 ${formData.contactbg === 'Dark' ? 'bg-gray-900 text-white' : 'bg-gray-100 text-gray-600'}`}
      />

      <NewCustomInput
        label={<span>Email</span>}
        id="email"
        name="email"
        type="email"
        value={formData.email || ''}
        onChange={handleChange}
        placeholder="Enter email address"
        error={errors.email || errors.contact}
        className={`w-full border border-gray-300 rounded-md py-2 px-3 ${formData.contactbg === 'Dark' ? 'bg-gray-900 text-white' : 'bg-gray-100 text-gray-600'}`}
      />

      <div className="text-sm text-gray-600 mt-2">
        * At least one of WhatsApp, Contact No., or Email is required
      </div>
    </div>
  );
};

Div6.propTypes = {
  formData: PropTypes.shape({
    contactbg: PropTypes.string,
    whatsapp: PropTypes.string,
    mobile: PropTypes.string,
    email: PropTypes.string,
  }).isRequired,
  setFormData: PropTypes.func.isRequired,
  errors: PropTypes.object.isRequired,
  setErrors: PropTypes.func.isRequired,
  handleChange: PropTypes.func.isRequired,
};

export default Div6;